import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useState, useEffect, useMemo } from 'react';
import { Column } from 'react-table';
import { useSearchParams, useParams } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import { useApiClient } from '../../hooks/useApiClient';
import { useAuth } from '../../hooks/useAuth';
import VehicleTableContainer from '../../components/VehicleTable/VehicleTableContainer';
import QuotationListTableContainer from '../../components/QuotationList/QuotationListTableContainer';
import { columnsDataWishlist } from '../../components/VehicleTable/columnsDataWishlist';
import { ColumnsDataQuotationList } from '../../components/QuotationList/ColumnsDataQuotationList';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import { useRefresh } from '../../hooks/useRefresh';
import { RoleEnum } from '../../api';
import toaster from '../../utils/toaster';

const WishlistPage = () => {
	const { apiClient, handleApi } = useApiClient();
	const { user, userRole } = useAuth();
	const [searchParams] = useSearchParams();
	const [itsMe, setItsMe] = useState(false)
	const { t } = useTranslation()

	const [response, setResponse]: [any, any] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [quotationsResponse, setQuotationsResponse]: [any, any] = useState(null);
	const [quotationsLoading, setQuotationsLoading] = useState(false);
	const [quotationsError, setQuotationsError] = useState(null);
	const [businessName, setBusinessName] = useState('')
	const { username } = useParams<{ username: string }>();
	const refresh = useRefresh();
	// const businessName = localStorage.getItem('business_name');

	const deleteWishlistFunc = (vehicleId) => {
		handleApi(apiClient.vehicleController.deleteWishlist(vehicleId))
			.then((res) => {
				toaster.success(i18next.t("bookmarked_vehicle_removed_success")) // 'Il veicolo è stato rimosso con successo dai preferiti');
				setLoading(false);
				refresh();
			})
			.catch((err) => {
				setError(err);
				setLoading(false);
				toaster.error(
					err.message || i18next.t("bookmarked_vehicle_removed_error") //"Errore non specificato durante l'eliminazione dei dati"
				);
			});
	};

	useEffect(() => {
		user.username === username && setItsMe(true)

		handleApi(apiClient.vehicleController.getWishlist(username ? username : user.username))
			.then((res) => {
				res.forEach((elem) => {
					elem.deleteWishlist = deleteWishlistFunc;
					elem.in_wishlist = false;
				});
				setResponse(res);
				setLoading(false);
			})
			.catch((err) => {
				setError(err);
				setLoading(false);
			});

		if (username) {
			handleApi(apiClient.vehicleController.getQuotationRequests(username))
				.then((res) => {
					setQuotationsResponse(res);
					setQuotationsLoading(false);
				})
				.catch((err) => {
					setQuotationsError(err);
					setQuotationsLoading(false);
					toaster.error(
						err.message || i18next.t("quotation_request_error")
					);
				});
		}

		const businessName = localStorage.getItem('business_name') ?? '';
		handleApi(apiClient.salesforceAccountController.getAccount(businessName))
			.then(accountRes => {
				setBusinessName(accountRes.data[0]?.Name)
			})
			.catch(err => {
				console.error(err);
			})

	}, []);

	const columns = useMemo(() => columnsDataWishlist as Column<Object>[], []);
	const data = useMemo(() => response ?? [], [response]);

	const quotationsColumns = useMemo(() => ColumnsDataQuotationList as Column<Object>[], []);
	const quotationsData = useMemo(() => quotationsResponse ?? [], [quotationsResponse]);

	const filterIntialState = {
		marca: [],
		modello: [],
		allestimento: [],
		carrozzeria: [],
		colore_esterno: [],
		colore_interno: [],
		telaio: '',
		targa: '',
		alimentazione: '',
		cambio: '',
		trazione: [],
	}

	return (
		<Container fluid>
			<Row>
				<Col md={12} className="display-6">
					{username ? `${i18next.t("bookmarks_of")} ${businessName}` : i18next.t("my_bookmarks")}
				</Col>
			</Row>

			<ErrorBoundary>
				<VehicleTableContainer
					columns={columns}
					data={data}
					loading={loading}
					error={error}
					hiddenColumns={['id']}
					filterIntialState={filterIntialState}
				></VehicleTableContainer>
			</ErrorBoundary>

			{userRole !== RoleEnum.FLEET_MANAGER ?
				<div>
					<Row>
						<Col md={12} className="display-6">
							{t("quotation_list_request")}
							{/*  Lista Richieste Preventivi */}
						</Col>
					</Row>
					<ErrorBoundary>
						<QuotationListTableContainer
							columns={quotationsColumns}
							data={quotationsData}
							loading={quotationsLoading}
							error={quotationsError}
						></QuotationListTableContainer>
					</ErrorBoundary>
				</div>
				: ""
			}
		</Container>
	);
};

export default WishlistPage;
